import {CSSProperties, FC} from 'react';


export interface IIconSearchAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSearchAvito: FC<IIconSearchAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M15.378 4.01a14.187 14.187 0 0 0-3.231.678c-.665.23-2.028.909-2.611 1.298-1.902 1.272-3.344 2.914-4.32 4.918-.572 1.178-.919 2.31-1.123 3.67-.11.738-.126 2.41-.028 3.148.327 2.464 1.235 4.55 2.792 6.416 3.424 4.102 9.178 5.493 14.146 3.42 1.056-.44 2.066-1.052 3.081-1.863l.2-.16 3.214 3.209c3.173 3.168 3.217 3.21 3.472 3.246a.871.871 0 0 0 .968-1.097c-.049-.189-.492-.655-3.239-3.405-2.423-2.427-3.168-3.204-3.125-3.259.03-.04.175-.22.32-.4.72-.893 1.525-2.354 1.915-3.478.44-1.268.627-2.296.669-3.675.065-2.136-.3-3.897-1.192-5.738-.668-1.379-1.42-2.417-2.54-3.5-2.256-2.187-5.079-3.361-8.245-3.431a17.58 17.58 0 0 0-1.123.003Zm1.811 1.777c4.736.462 8.52 3.913 9.395 8.567.163.865.2 2.411.078 3.286-.49 3.533-2.62 6.487-5.808 8.055-3.316 1.63-7.259 1.381-10.377-.657-4.244-2.774-5.89-8.22-3.903-12.906.791-1.866 2.22-3.565 3.95-4.696C12.48 6.16 14.89 5.563 17.19 5.787Zm-1.373 4.894c-.432.26-.426.224-.455 2.586l-.025 2.097-2.125.015c-2.047.015-2.13.02-2.275.129-.288.214-.377.39-.377.736s.09.52.377.736c.145.108.228.113 2.283.128l2.132.015v2.054c0 2.274 0 2.278.35 2.585.395.348 1.05.214 1.294-.264.102-.2.108-.33.108-2.295V17.12h2.128c2.115 0 2.128 0 2.313-.123.104-.07.245-.242.32-.391.121-.246.126-.288.065-.52a.913.913 0 0 0-.64-.659c-.15-.038-.967-.06-2.216-.06h-1.98l.018-2.099.019-2.099-.146-.22a.846.846 0 0 0-1.168-.268Z" clipRule="evenodd" />
        </svg>
    );
};
